import React from 'react';
import './Btn.css';

const MainBtn = (props) => {
    return ( 
        <button className={props.btnStyle}>
            <span>{props.btnText}</span>
        </button>
     );
}
 
export default MainBtn;